import ModelService from '../base/ModelService';

class UserAgreement extends ModelService {
  constructor() {
    super('eula');
  }
}

export default new UserAgreement();
